module.exports = __webpack_public_path__ + "assets/img/24d043c111c603a7fec5df09889a4562.svg";